import InstallmentItem from './installment-item';

export default InstallmentItem;
